module.exports = __webpack_public_path__ + "static/media/exe-card-bg.13e5edc9.jpg";